<template>
  <div>
    <div v-cloak v-for="item in this.estates.slice(itemNumber, itemNumber + 1)">
      <InfoWindow
        :geoWerftData="geoWerftData"
        :image_url="item.image_url"
        :win_objekttitel="item.win_objekttitel"
        :win_plz="item.win_plz"
        :win_ort="item.win_ort"
        :win_geolocation="item.win_geolocation"
        :win_objektart_raw="item.win_objektart_raw"
        :win_kennung="item.win_kennung"
        :win_res_begin="item.win_res_begin"
        :win_res_ende="item.win_res_ende"
        :win_price="item.win_price"
        :win_price_rent="item.win_price_rent"
        :win_display_badge_new="item.win_display_badge_new"
        :win_erwerbsart="item.win_erwerbsart"
        :win_homepage_status="item.win_homepage_status"
        :win_count_adults="item.win_count_adults"
        :win_count_childs="item.win_count_childs"
        :win_barrierefrei="item.win_barrierefrei"
        :win_haustiere="item.win_haustiere"
        :win_price_qm="item.win_price_qm"
        :win_teilbarkeit="item.win_teilbarkeit"
        :win_bueroflaeche="item.win_bueroflaeche"
        :win_bezug="item.win_bezug"
        :win_zimmer="item.win_zimmer"
        :win_wohnflaeche="item.win_wohnflaeche"
        :win_vermietbare_flaeche="item.win_vermietbare_flaeche"
        :win_grundstuecksflaeche="item.win_grundstuecksflaeche"
        :win_link_extern="item.win_link_extern"
        :win_link_extern_url="item.win_link_extern_url"
        :permalink="item.permalink"
      ></InfoWindow>
    </div>
    <div class="paginator_area">
      <div class="left-icon">
        <i
          v-if="itemNumber > 0"
          class="fa fa-chevron-circle-left"
          aria-hidden="true"
          v-on:click="prev()"
        ></i>
      </div>
      <div class="info-area">
        Angebot <br />
        {{ itemNumber + 1 }} von {{ this.estates.length }}
      </div>
      <div class="right-icon">
        <i
          v-if="itemNumber < this.estates.length - 1"
          class="fa fa-chevron-circle-right"
          aria-hidden="true"
          v-on:click="next()"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import InfoWindow from "./InfoWindow";
export default {
  name: "InfoWindowPaginator",
  components: { InfoWindow },
  data() {
    return {
      reload: 0,
      itemNumber: 0,
      itemLength: 0,
      items: [],
      currentItem: [],
    };
  },
  props: ["estates", "geoWerftData"],
  methods: {
    next() {
      this.itemNumber++;
    },
    prev() {
      this.itemNumber--;
    },
  },
  watch: {
    estates: function (newVal, oldVal) {
      this.itemNumber = 0;
    },
  },
};
</script>

<style scoped>
.paginator_area {
  width: 100%;
  height: auto;
  min-height: 1px;
  overflow: hidden;
  margin-top: 16px;
  padding: 4px;
}
.info-area {
  text-align: center;
  width: 30%;
  height: auto;
  min-height: 1px;
  overflow: hidden;
  float: left;
}
.left-icon {
  float: left;
  text-align: center;
  font-size: xx-large;
  width: 35%;
  height: auto;
  min-height: 1px;
  overflow: hidden;
}
.right-icon {
  float: right;
  text-align: center;
  font-size: xx-large;
  width: 35%;
  height: auto;
  min-height: 1px;
  overflow: hidden;
}
.fa {
  position: unset;
}
</style>



// WEBPACK FOOTER //
// src/components/InfoWindowPaginator.vue